module.exports = __webpack_public_path__ + "img/message_icon.b8c78c7d.svg";